module.exports = __webpack_public_path__ + "static/media/icon-pdf.68229bb0.svg";